.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.properties {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.content {
  max-width: 75.2rem;
  flex: 1;
  overflow-y: scroll;

  @media screen and (min-width: $bp-small) {
    width: 75.2rem;
    max-width: 75.2rem;
  }
}
